import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import type { IssueWorkflowOutDto } from 'shared/domain/workflow/types';
import {
  broadcastCreatedWorkflow,
  broadcastUpdatedWorkflow,
} from 'serviceWorker/broadcasts/workflow/one';
import { broadcastWorkflowError } from 'serviceWorker/broadcasts/workflow/error';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { neverReached } from 'shared/utils/neverReached';

export function broadcastWorkflowResponse(
  request: HttpRequestEntity,
  response: IssueWorkflowOutDto | { error: unknown }
): void {
  if ('error' in response && response.error) {
    return broadcastWorkflowError(response.error, request.data.uniqueId, chooseErrorMessage(response.error));
  }

  switch (request.method) {
    case 'POST':
      return broadcastCreatedWorkflow(
        response as IssueWorkflowOutDto,
        request.data.uniqueId
      );
    case 'PUT':
      return broadcastUpdatedWorkflow(
        response as IssueWorkflowOutDto,
        request.data.uniqueId
      );
    case 'DELETE':
    case 'GET':
      return broadcastWorkflowError(
        new Error(`${request.method} method not supported for workflow`),
        request.data.uniqueId
      );
    default:
      neverReached(request.method);
  }
}
